<template>
  <div class="main-wrapper">
    <table>
      <tr>
        <td>
          <radar-spinner :animation-duration="2000" :size="100" color="#06569b" />
        </td>
        <td class="right">
          <p>Запрос сформирован и отправлен.</p>
          <p>Получение ответа может занять несколько минут!</p>
          <p>Последний опрос сервера: {{time}}</p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import moment from "moment";

import { RadarSpinner } from "epic-spinners";
export default {
  name: "LoadingFromServer",
  props: {},
  components: {
    RadarSpinner
  },
  data: () => ({
    time: "",
    data: []
  }),
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  },
  async created() {
    this.time = moment(Date.now()).format("HH:mm:ss");
    while (this.data.length == 0) {
      await this.sleep(3000);
      this.time = moment(Date.now()).format("HH:mm:ss");
    }
  }
};
</script>

<style scoped>
.main-wrapper {
  text-align: center;
  justify-content: center;
  margin-left: 25%;
  margin-top: 10%;
}
</style>